"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FamilyOwnedTrust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section ref={ref} className={`relative min-h-[600px] grid md:grid-cols-[40%_60%] transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      {}
      <div className="relative bg-dark-background overflow-hidden">
        <div className={`absolute inset-0 bg-black/30 z-10 transition-opacity duration-[var(--duration-slow)] ${isVisible ? "opacity-100" : "opacity-0"}`} />
        <div className={`relative h-full transition-all duration-700 ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/image_pusiv3gq.jpg" alt="Mike at work in his fire protection workshop" className="w-full h-full object-cover" />
        </div>
      </div>

      {}
      <div className="absolute left-[40%] top-0 bottom-0 w-1 bg-primary z-20 hidden md:block" />

      {}
      <div className="relative bg-light-background flex flex-col justify-center px-8 md:px-16 py-16">
        <div className={`space-y-6 transition-all duration-700 ease-[var(--ease-out-back)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground leading-tight">
            Family-Owned Trust You Can Count On
          </h2>

          <p className="text-lg text-secondary leading-relaxed max-w-2xl">
            At A+ Fire, you're not just another number. When you call, you speak directly with Mike—our owner and certified technician who personally handles every service call. No secretaries, no call centers, just honest, hands-on fire protection services backed by years of expertise. We're a family-owned business serving Northern Virginia with fast response times, certified work, and the kind of trust that only comes from dealing directly with the owner.
          </p>

          <div className={`inline-flex items-center gap-3 mt-8 transition-all duration-700 ease-[var(--ease-out-back)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/certified_trust_badge.png" alt="Certified and Insured" className="h-20 w-auto object-contain" />
            <div className="text-sm text-muted-foreground">
              <p className="font-semibold text-foreground">Certified & Insured</p>
              <p>Direct Owner Contact Guaranteed</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}